import { LogoImgAttraction } from '../../../Files/LogoImgAttraction.js';
import { LogoParksAndUnivers } from '../../../Files/LogoParksAndUnivers.js';
import { LogoImgOrigin } from '../../../Files/LogoImgOrigin.js';
import { LogoImgDefault } from '../../../Files/LogoImgDefault.js';
import { Slugify } from '../../Admin/Functions/Slugify.js';

export const CarrouselDatas = (label, datas) => {
    const collection = [];
    switch (label) {
        default:
        case 'home':
        case 'univers':
            datas.map((el) => {
                collection.push({
                    slug: el.aslug,
                    name: el.aname,
                    href: el.aroute,
                    images: LogoImgAttraction('icon', el.cslug, el.aslug),
                });
                return collection;
            });
            break;
        case 'park':
            datas.map((el) => {
                collection.push({
                    slug: el.uslug,
                    name: el.uname,
                    href: el.uroute,
                    images: LogoParksAndUnivers('univers', el.uslug)
                });
                return collection;
            });
            break;
        case 'attraction':
            datas.map((el) => {
                collection.push({
                    slug: el.aslug,
                    name: el.aname,
                    href: el.aroute,
                    images: LogoImgAttraction('img', el.cslug, el.aslug),
                });
                return collection;
            });
            break;
        case 'archive':
            datas.map((el) => {
                collection.push({
                    slug: el.aslug,
                    name: el.aname,
                    href: el.aroute,
                    category: el.cslug,
                    images: LogoImgAttraction('img', el.cslug, el.aslug),
                });
                return collection;
            });
            break;
        case 'experiment':
            datas.map((el) => {
                collection.push({
                    name: el.name,
                    href: el.route,
                    images: LogoImgDefault('img'),
                });
                return collection;
            });
            break;
        case 'origin':
            datas.map((el) => {
                collection.push({
                    oslug: el.oslug,
                    oname: el.oname,
                    images: LogoImgOrigin('img', Slugify(el.otname), el.oslug),
                });
                return collection;
            });
            break;
        case 'character':
            datas.map((el) => {
                collection.push({
                    name: el.cname,
                    href: el.croute,
                    images: LogoImgDefault('img'),

                });
                return collection;
            });
            break;
    }
    return collection;
}
